// Spirit Admin — Resource Library content config (CMS-lite).
// To add a new article image, add one entry to ARTICLE_IMAGES keyed by the
// article title. Article copy itself is served from the backend /api/resources.
import { Dumbbell, Fingerprint, HeartPulse, Compass, Sparkle, Brain } from "lucide-react";
import { BRAND } from "../lib/brand";

export const CATEGORIES = [
  { name: "Discipline", icon: Dumbbell, color: "#4da6ff", img: BRAND.categories.Discipline },
  { name: "Identity", icon: Fingerprint, color: "#a78bfa", img: BRAND.categories.Identity },
  { name: "Healing", icon: HeartPulse, color: "#34d399", img: BRAND.categories.Healing },
  { name: "Purpose", icon: Compass, color: "#fb7185", img: BRAND.categories.Purpose },
  { name: "Faith", icon: Sparkle, color: "#fbbf24", img: BRAND.categories.Faith },
  { name: "Mindfulness", icon: Brain, color: "#22d3ee", img: BRAND.categories.Mindfulness },
];

// Per-article cinematic artwork. Falls back to the category image when absent.
export const ARTICLE_IMAGES = {
  "Finding Purpose in the Process": "/brand/res_purpose.webp",
  "Reclaiming Your Identity": "/brand/res_identity.webp",
  "The Architecture of Discipline": "/brand/res_discipline.webp",
};

export const catMeta = (name) => CATEGORIES.find((c) => c.name === name) || CATEGORIES[0];

export const articleImage = (r) => r?.image || ARTICLE_IMAGES[r?.title] || catMeta(r?.category).img;
